import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { IApiResult } from '../../interface/IApiResult';
import { apiPayMemmoryConfirm } from '../../service/apiPayMemmoryConfirm';

export const AutoConfirm = () => {
  const { lendingId, appId } = useParams();
  const autoUrl = async () => {
    const apiResult: IApiResult = await apiPayMemmoryConfirm(
      lendingId ?? '',
      appId ?? ''
    );
    if (apiResult.isSuccess) {
      if (apiResult.data.url !== '') {
        window.location.replace(apiResult.data.url);
      }
    }
  };

  useEffect(() => {
    if (lendingId !== undefined && appId !== undefined) {
      autoUrl();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div> </div>;
};
